// extracted by mini-css-extract-plugin
export var closeButton = "_hc-1";
export var closeX = "_hc-3";
export var container = "_hc-0";
export var image = "_hc-2";